import { useEffect, useRef } from 'react'
import { useAppSelector } from 'hooks'
import { useBindDispatch } from './useBindDispatch'
import { constants } from 'helpers'

export const usePaymentPolling = (
    timerEndCallback: () => void,
    durationOfPolling = constants.MOBILE_PAYMENT_SPINNER_TIMEOUT_IN_MS,
    pollingIntervalInMs = constants.MOBILE_PAYMENT_POLLING_INTERVAL_IN_MS
) => {
    const timerRef = useRef<NodeJS.Timeout | null>(null)
    const { uuid, status } = useAppSelector((store) => store.mobilePayment)
    const { checkPaymentConfirmationHandler } = useBindDispatch()
    let nbOfPoll = 0

    const startPollingPayment = (paymentUuid: string) => {
        if (timerRef.current) {
            clearInterval(timerRef.current)
        }

        timerRef.current = setInterval(() => {
            checkPaymentConfirmationHandler(paymentUuid)
            nbOfPoll++
            if (nbOfPoll >= durationOfPolling / pollingIntervalInMs) {
                timerEndCallback()
                stopPollingPayment()
                nbOfPoll = 0
            }
        }, pollingIntervalInMs)
    }

    const stopPollingPayment = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current)
            timerRef.current = null
        }
    }

    useEffect(() => {
        if (
            status === constants.MOBILE_MONEY.SUCCESS ||
            status === constants.MOBILE_MONEY.FAILURE
        ) {
            stopPollingPayment()
        }
    }, [status])

    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current)
            }
        }
    }, [])

    return {
        startPollingPayment,
        stopPollingPayment,
        uuid,
        status
    }
}
